var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSendArrow = function SvgSendArrow(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0956 1.90438C14.962 1.77086 14.7952 1.67537 14.6124 1.62775C14.4296 1.58013 14.2375 1.58209 14.0557 1.63345H14.0457L1.29971 5.50095C1.09279 5.56058 0.908869 5.68169 0.772328 5.84821C0.635787 6.01474 0.55307 6.21882 0.535138 6.43342C0.517207 6.64802 0.564908 6.863 0.67192 7.04988C0.778932 7.23676 0.940203 7.3867 1.13436 7.47985L6.77358 10.2264L9.51616 15.8623C9.60146 16.0443 9.73708 16.1982 9.907 16.3056C10.0769 16.413 10.274 16.4696 10.4751 16.4686C10.5056 16.4686 10.5362 16.4673 10.5667 16.4646C10.7811 16.4473 10.9851 16.3647 11.1513 16.2281C11.3175 16.0915 11.4379 15.9073 11.4964 15.7003L15.3612 2.95427C15.3612 2.95095 15.3612 2.94763 15.3612 2.9443C15.4133 2.76299 15.4161 2.5711 15.3694 2.38834C15.3227 2.20558 15.2282 2.03854 15.0956 1.90438ZM10.481 15.3961L10.4777 15.4054V15.4008L7.81749 9.93555L11.005 6.74805C11.1004 6.64762 11.1528 6.51387 11.151 6.37534C11.1493 6.23681 11.0935 6.10446 10.9955 6.00649C10.8975 5.90853 10.7652 5.85271 10.6266 5.85094C10.4881 5.84916 10.3544 5.90158 10.2539 5.997L7.06643 9.1845L1.59921 6.52427H1.59456H1.60385L14.3439 2.6561L10.481 15.3961Z",
    fill: "white"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSendArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/send-arrow.418f9feb32ec82cbe9fb8424e2e83929.svg";